module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Acknowledgments#fm-1"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Abbreviations#fm-2"
    }
  }, [_c('em', [_vm._v("List of Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#fm-3"
    }
  }, [_vm._v("Introduction: Inventing the “Divine Self”"), _c('br'), _c('em', [_vm._v("Where We Are Headed")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#ch-1"
    }
  }, [_vm._v("1. "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("Survivor to Shaman"), _c('br'), _c('em', [_vm._v("Discovering the Divine Self")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("Dancing for Dionysus"), _c('br'), _c('em', [_vm._v("New Myths for the Utopian Stage")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("Shaman to Sage"), _c('br'), _c('em', [_vm._v("Religion of the One")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("“The True Mystics” "), _c('br'), _c('em', [_vm._v("Orpheus as Plato’s Muse")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("“The Foes! The Foes!” "), _c('br'), _c('em', [_vm._v("Soul Saving in Alexandria")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("Hermes Trismegistus"), _c('br'), _c('em', [_vm._v("The Cult without Temples")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("Savior "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("of")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("from")]), _vm._v(" the World? "), _c('br'), _c('em', [_vm._v("Christianity and Gnosis")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("Orphic Exegesis"), _c('br'), _c('em', [_vm._v("The Eternal Gospel")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("A Christian Reconstruction of Late Neoplatonism"), _c('br'), _c('em', [_vm._v("St. Paul’s Philosopher-Convert")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("Cosmotheism as Philosophical Religion"), _c('br'), _c('em', [_vm._v("Eriugena’s Dionysius")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("Prophetic Gnosis"), _c('br'), _c('em', [_vm._v("Dreaming of Utopia")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/020_WorksCited#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Works Cited")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60dfd2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0